import {AvailableGridCols} from '../../../design-system/atoms/Grid/AvailableGridCols.type';
import {theme} from '../../../theme';
import {useWindowInnerWidth} from './useWindowInnerWidth';

interface UseCurrentGridColsParams {
  cols: AvailableGridCols;
  foldableCols?: AvailableGridCols;
  tabletCols?: AvailableGridCols;
}

/**
 * 현재 화면 크기에서 실제로 적용되는 Grid의 열 수를 반환합니다.
 * foldableCols 또는 tabletCols가 설정되어 있으면 해상도에 따라 적절한 값을 반환합니다.
 */
export function useCurrentGridCols({
  cols,
  foldableCols,
  tabletCols,
}: UseCurrentGridColsParams): AvailableGridCols {
  const innerWidth = useWindowInnerWidth();

  // tabletCols가 설정된 경우
  if (tabletCols) {
    const tabletBreakpoint = Number(theme.screens.tablet.replace('px', ''));
    return innerWidth >= tabletBreakpoint ? tabletCols : cols;
  }

  // foldableCols가 설정된 경우
  if (foldableCols) {
    const foldableBreakpoint = Number(theme.screens.foldable.replace('px', ''));
    return innerWidth >= foldableBreakpoint ? foldableCols : cols;
  }

  // 반응형 설정이 없으면 기본 cols 반환
  return cols;
}
